export default function Header({ isSubpage = false }) {
  return (
    <header className={`rz-header ${isSubpage ? "rz-header--subpage" : ""}`}>
      <div className="rz-shell rz-header__inner">
        <a href={isSubpage ? "/" : "#top"} className="rz-logo-wrap" aria-label="Rezervix">
          <img
            src="/images/logo_alb_rezervix.png"
            alt="Rezervix"
            className="rz-logo"
          />
        </a>

      {isSubpage ? (
              <>
                <a href={isSubpage ? "/#lead-form" : "#lead-form"} className="rz-header__cta">
                  Solicită o solutie
                </a>
              </>
      ) : (<></>)}
      
      </div>
    </header>
  );
}
